import React from "react";

import { Input } from "../../../../../components/input/Input";
import { useIntlTranslate } from "../../../../../hooks";

import "./ProtectionSearch.scss";

interface ProtectionSearchProps {
  inputId: string;
  onChange: (value: string) => void;
  filterValue: string;
  disabled?: boolean;
}

export const ProtectionSearch = ({
  inputId,
  onChange,
  filterValue,
  disabled = false,
}: ProtectionSearchProps) => {
  const translate = useIntlTranslate();

  const handleInputChange = (value: string): void => {
    onChange(value);
  };

  return (
    <div className="search-section">
      <Input
        id={inputId}
        icon="fa-regular fa-fw fa-search"
        className={"web-filters__search"}
        placeholder={translate("protection_category_input_placeholder")}
        onClear={() => handleInputChange("")}
        onChange={({ target: { value } }) => handleInputChange(value)}
        autoComplete="off"
        value={filterValue}
        aria-label={translate("aria_protection_category_input_placeholder")}
        disabled={disabled}
      />
    </div>
  );
};
